import 'lazysizes';

function getImage(imageUrl, imageHolder) {
  let newImage = document.createElement('img');
  newImage.src = imageUrl;
  newImage.onload = function() {
    imageHolder.style.backgroundImage = "url('" + newImage.src + "')";
    imageHolder.setAttribute('data-bg', newImage.src);
  };
}

export function resizeBackgroundImages(responsiveImages) {
  for (var i = 0; i < responsiveImages.length; i++) {
    const responsiveImage = responsiveImages[i];
    const windowWidth = window.innerWidth;
    const sizes = responsiveImage.getAttribute('data-sizes').split(',');
    const largeImage = responsiveImage.getAttribute('data-large_image');
    let flag = false;

    if (responsiveImage.classList.contains('lazyloaded')) {
      for (let i = 0; i < sizes.length; i++) {
        const size = sizes[i];
        const image = size.split('@@@')[0];
        const mediaQuery = size.split('@@@')[1];

        if (!flag) {
          if (windowWidth <= mediaQuery) {
            getImage(image, responsiveImage);
            flag = true;
          } else {
            getImage(largeImage, responsiveImage);
          }
        }
      }
    }
  }
}

function initResponsiveImages() {
  const eventsToListen = ['load', 'resize', 'scroll'];

  eventsToListen.forEach(function(event) {
    window.addEventListener(event, function() {
      const targetImages = document.querySelectorAll('.responsive-background-image');
      resizeBackgroundImages(targetImages);
    });
  });
}

initResponsiveImages();
